























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class FileUpload extends Vue {
  @Prop() private label!: string;
  @Prop() private labelPrefix!: string;
  @Prop() private labelSuffix!: string;
  @Prop({default: '*/*'}) private accept!: string;

  private uploadFile(file: any) {
    this.$emit('onupload', file);
  }
}
